function Login() {

  function initMobileIdDialog() {
    $('#phoneNumber').focus()
  }

  function startMobileID() {
    return $.post('/login/mobile-id', {
      phoneNumber: $('#phoneNumber').val(),
      nationalIdentityNumber: $('#nationalIdentityNumber').val()
    })
  }

  function showChallengeAndWait(result) {
    $('#controlCode').removeAttr('hidden')
    $('#challenge').text(result.challenge)
    return $.get('/login/mobile-id')
  }

  function loginDone(result) {
    $('#controlCode').attr("hidden", "hidden")
    $('#loginModal').modal('hide')
    window.session = new Session(result.user, result.authType)
    $('#login-link').hide()
    location.href = '#loading'
  }

  function loginFail(xhr) {
    $('#controlCode').attr("hidden", "hidden")
    $('#mobile-id-submit').attr('disabled', false)
    $('#id-card-submit').attr('disabled', false)
    if (xhr.status === 412) {
      $('#loginModal').modal('hide')
      $('#underAge').collapse('show')
    }
    else
      $('#loginFailed').removeAttr('hidden').find('#reason').text((xhr.responseJSON || {}).reason)
  }

  function IDCard() {
    hideLoginAlert()
    $('#id-card-submit').attr('disabled', true)
    $.get('/login/e-id/challenge').done(authenticateWithChallenge)
  }

  function hideLoginAlert() {
    $('#loginFailed').attr("hidden", "hidden")
  }

  async function authenticateWithChallenge(challenge) {
    const authToken = await webeid.authenticate(challenge.nonce, {lang: 'et'});
    $.post('/login/e-id/authenticate', authToken)
      .done(loginDone)
      .fail(loginFail)
  }

  function mobileID() {
    hideLoginAlert()
    $('#mobile-id-submit').attr('disabled', true)
    $.when(startMobileID())
      .then(showChallengeAndWait)
      .done(loginDone).fail(loginFail)
  }

  function submitNumber(event) {
    if (event.which === 13) mobileID()
  }

  function renderLoginModal(config) {
    $('#login-view-container').html(Handlebars.compile($('#login-view-template').html())(config))
  }

  function showLoginModal(e) {
    var link = $(e.target)
    if (!link.hasClass('disabled')) {
      $('#loginModal').modal('show')
    }
  }

  this.init = function (config) {
    renderLoginModal(config)

    var body = $('body')
    body.on('shown.bs.tab', '#loginModal #login-tab-mobile-id', initMobileIdDialog)
    body.on('click', '#id-card-submit', IDCard)
    body.on('click', '#mobile-id-submit', mobileID)
    body.on('keyup', '#phoneNumber', submitNumber)
    $('#login-link').click(showLoginModal)

    $('#loginModal').on('shown.bs.modal', function () {
      $('#phoneNumber').focus();
    })
  }
}
